<template>
  <j-modal
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :title="title"
    :closable="true"
    @close="handleCancel"
    @cancel="handleCancel"
    :visible="visible"
    :footer="null"
    :fullscreen.sync="modal.fullscreen"
    >

    <div>
      <!-- actions -->
      <a-button-group style="margin-right: 4px;">
        <a-select v-model="stepAction">
          <a-select-option value="">--请选择--</a-select-option>
          <a-select-option v-for="(item, key) in actionList" :key="key" :value="item.code">{{item.code}}-{{item.value}}</a-select-option>
        </a-select>
        <a-button @click="submit(lcsjViewDate)" type="primary">提交</a-button>
      </a-button-group>
      <a-button-group style="margin-right: 4px;">
        <a-button @click="forceGetFlow(lcsjViewDate)">切换当前操作人</a-button>
        <a-button @click="lcsjglGq(lcsjViewDate)">挂起</a-button>
        <a-button @click="lcsjglFh(lcsjViewDate)">恢复</a-button>
        <a-button @click="lcsjglGb(lcsjViewDate)">关闭</a-button>
        <a-button @click="openDetailWp(lcsjViewDate)">委派</a-button>
        <a-button @click="openDetailTz(lcsjViewDate)">跳转</a-button>
        <a-button><a-icon type="ellipsis"/></a-button>
      </a-button-group>
      <a-button type="primary" >主操作</a-button>

    </div>
    
    <a-card size="small" style="margin-top: 24px;" :bordered="true" title="流程日志">
      <div style="overflow-y: auto; height: 300px; padding: 3px;">
      <a-timeline>
        <a-timeline-item>
            <a-icon slot="dot" type="clock-circle-o" style="font-size: 16px;" />
            <span class="hszt">当前步骤：{{ current.step }}</span>
            <a-divider type="vertical"/>
            <span class="hszt">步骤名称：{{current.stepName}}</span>
            <a-divider type="vertical"/>
            <span class="hszt">处理人:{{ current.currentUser }}</span>
            <a-divider type="vertical"/>
            <span class="hszt">处理角色：{{ current.currentRole }}</span>
          </a-timeline-item>
        <div v-for="(item, key) in flowLogList" :key="key">
          <a-timeline-item color="green">
            <span class="hszt">操作步骤：{{ item.step }}</span>
            <a-divider type="vertical"/>
            <span class="hszt">操作类型：{{item.flowAction}}</span>
            <a-divider type="vertical"/>
            <span class="hszt">操作人:{{ item.updateUser }}</span>
            <a-divider type="vertical"/>
            <span class="hszt">操作时间：{{ item.updateDate }}</span>
          </a-timeline-item>
        </div>
      </a-timeline>
    </div>
    </a-card>

    <a-card size="small" style="margin-top: 24px" :bordered="true" title="流程实例信息">
      <detail-list>
        <detail-list-item term="流程名称">{{lcsjViewDate.flowTypeName}}</detail-list-item>
        <detail-list-item term="客户姓名">{{lcsjViewDate.buzUser}}</detail-list-item>
        <detail-list-item term="流程ID">{{lcsjViewDate.flowType}}</detail-list-item>
        <detail-list-item term="流程实例">{{lcsjViewDate.id}}</detail-list-item>
        <detail-list-item term="发起人">{{lcsjViewDate.startUser}}</detail-list-item>
        <detail-list-item term="办理角色">{{lcsjViewDate.currRoleName}}</detail-list-item>
       </detail-list> 
       <detail-list>
        <detail-list-item term="办理人">{{lcsjViewDate.currUser}}</detail-list-item>
        <detail-list-item term="开始时间">{{lcsjViewDate.startDate}}</detail-list-item>
        <detail-list-item term="状态">{{lcsjViewDate.flowStatus}}</detail-list-item>
      </detail-list>
    </a-card>

  </j-modal>
</template>


<script>
import { mixinDevice } from '@/utils/mixin.js'
import PageLayout from '@/components/page/PageLayout'
import DetailList from '@/components/tools/DetailList'
import '@/assets/less/TableExpand.less'
import { httpAction, getAction, postParam} from '@/api/manage'

const DetailListItem = DetailList.Item
export default {
  name: 'LcsjView',
  components: {
    PageLayout,
    DetailList,
    DetailListItem
  },
  mixins: [mixinDevice],
  data() {
    return {
      title: '详情',
      visible: false,
      modal: {
        fullscreen: false,
      },
      // 动作列表
      actionList: [],
      current: {},
      stepAction: 'default',
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },

      drawerWidth:1000,
      indexStyle: 1,
      flowLogList: [],

      comments: '',
      buttonStatu: false,
      lcsjViewDate: {},
      processType: '1',
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      url: {
        currentStep: '/okflow/flow-data/current/step',
        list: '/okflow/flow-data/list/page',
        submit: '/okflow/flow-data/submit',
        hangup: '/okflow/flow-data/hangup',
        recovery: '/okflow/flow-data/recovery',
        close: '/okflow/flow-data/close',
        lcView: '/okflow/flow-data/list/flowlog',
      },
    }
  },
  methods: {
    doView(record)  {
      this.lcsjViewDate = record;
      this.visible = true;
      httpAction(this.url.lcView+"?flowId="+record.id,null,'get').then((res)=>{
        res = res.reverse();
        this.flowLogList = res;
      })
      getAction(this.url.currentStep, {flowId: record.id}).then((res)=>{
        if(res && res.result){
          this.current = res.result;
        }
      });
      getAction("/okflow/flow-data/list/actions", {flowId: record.id}).then((res)=>{
        this.actionList = res.result;
      })
    },
    close () {
      this.visible = false;
      this.$emit('close');
    },
    handleCancel () {
      this.close()
    },
    // 强制将流程切换到当前登录人员
    forceGetFlow(record) {
      postParam("/okflow/flow-data/force-get-flow", {flowId: record.id}).then((res)=>{
        this.$message.warning(res.message);
        this.doView(record);
      });
    },
    // 提交
    submit(record) {
      httpAction(this.url.submit+"?flowId="+record.id+"&action="+this.stepAction,null,'post').then((res)=>{
        this.$message.warning(res.message);
        this.doView(record);
      })
    },
    //挂起
    lcsjglGq(record) {
      httpAction(this.url.hangup+"?flowId="+record.id,null,'post').then((res)=>{
        this.$message.warning(res.message);
        this.loadData();
      })
    },
    //回复
    lcsjglFh(record) {
      httpAction(this.url.recovery+"?flowId="+record.id,null,'post').then((res)=>{
        this.$message.warning(res.message);
        this.loadData();
      })
    },
    //关闭
    lcsjglGb(record) {
      httpAction(this.url.close+"?flowId="+record.id,null,'post').then((res)=>{
        this.$message.warning(res.message);
        this.loadData();
      })
    },
    //委派
    openDetailWp(record) {  
      // httpAction(this.url.lcView+"?flowId="+record.id,null,'get').then((res)=>{
      //   this.flowLogList = res;
      // })
      this.$refs.lcsjgWp.toWp(record)
    },
    //跳转
    openDetailTz(record) {
      this.$refs.lcsjgTz.toTz(record)
    },
  }
}

</script>

<style lang="less" scoped>
  .hszt{
    color:#b5b0b0;
  }

    .detail-layout {
    margin-left: 44px;
  }
  .text {
    color: rgba(0, 0, 0, .45);
  }

  .heading {
    color: rgba(0, 0, 0, .85);
    font-size: 20px;
  }

  .no-data {
    color: rgba(0, 0, 0, .25);
    text-align: center;
    line-height: 64px;
    font-size: 16px;

    i {
      font-size: 24px;
      margin-right: 16px;
      position: relative;
      top: 3px;
    }
  }

  .mobile {
    .detail-layout {
      margin-left: unset;
    }
    .text {

    }
    .status-list {
      text-align: left;
    }
  }
</style>